module.exports = __webpack_public_path__ + "img/levelup-logo-accestance.704ac33b.svg";